import { render, staticRenderFns } from "./Cometencys.vue?vue&type=template&id=5448af04"
import script from "./Cometencys.vue?vue&type=script&lang=js"
export * from "./Cometencys.vue?vue&type=script&lang=js"
import style0 from "./Cometencys.vue?vue&type=style&index=0&id=5448af04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports